import type { Handler } from './handler';
import type {
  ApiFetchHomeMenuPort,
  HomeMenuItem,
} from './ports/api-fetch-home-menu.port';
import { tryCatch } from '~/utils/apostatudo/try-catch';
import { resolveAdapter } from '~/adapters/registry';
import homeMenuFallback from '~/assets/json/home-menu.fallback.json';

const CACHE_TTL_MS = 5 * 60 * 1000;

let lastGoodResponse: HomeMenuItem[] | null = null;
let lastGoodAt = 0;

export const fetchHomeMenuHandler: Handler<Params, Ports, Result> = async (
  ports = {
    apiFetchHomeMenu: resolveAdapter('apiFetchHomeMenu'),
  },
) => {
  // Serve cache while fresh — avoids hammering the API on every request.
  if (lastGoodResponse && Date.now() - lastGoodAt < CACHE_TTL_MS) {
    return lastGoodResponse;
  }

  const [items, error] = await tryCatch(ports?.apiFetchHomeMenu.handle());

  if (!error && items && items.length > 0) {
    lastGoodResponse = items;
    lastGoodAt = Date.now();

    return items;
  }

  if (error) {
    console.error('Error fetching home menu:', error);
  }

  // Stale cache > static fallback when the API is failing.
  if (lastGoodResponse) return lastGoodResponse;

  return homeMenuFallback as HomeMenuItem[];
};

type Params = undefined;

type Ports = {
  apiFetchHomeMenu: ApiFetchHomeMenuPort;
};

type Result = Promise<HomeMenuItem[]>;
